<template>
  <div class="container">
    <h2 class="mb-5">Input Section</h2>
    <form
      name="test"
      style="margin: 0 auto; max-width: 700px;"
      @submit.prevent="onSubmit"
    >
      <div v-if="!isLastInputWaste">
        <div class="base-control base-checkbox form-group form-check form-check-inline">
          <input
            class="styled-checkbox"
            type="radio"
            value="pre-c"
            id="one"
            v-model="prePostConsumer"
          >
          <label style="font-weight: normal;" class="mb-0" for="one">Pre-consumer</label>
        </div>
        <div class="base-control base-checkbox form-group form-check form-check-inline">
          <input
            class="styled-checkbox"
            type="radio"
            value="post-c"
            id="two"
            v-model="prePostConsumer"
          >
          <label style="font-weight: normal;" class="mb-0" for="two">Post-consumer</label>
        </div>
      </div>
        <div v-if="isLastInputWaste">
          <base-select
            select-label="name"
            name="material_waste"
            v-validate="'required'"
            label="Material waste"
            v-model="selectedInputWaste"
            :options="inputCompositionWaste"
            :searchable="true"
          >
          <template
            slot="right-container"
          >
            <base-button
              style-type="btn-block"
              component-class="blue style-250 mt-2 mt-xl-0 btn-block btn-custom-sm"
              @click.native="resetMaterialWaste"
            >New waste
            </base-button>
          </template>
        </base-select>
        <base-date
          name="month"
          v-validate="'required'"
          label="Month of processing"
          v-model="collection_date"
          format="YYYY-MM"
          :err="formErrors.month"
        />
        </div>
        <base-text
          name="volume"
          v-validate="'required|decimal|min_value:0'"
          :label="`Volume (${getWeightUnit})`"
          v-model="volumeGross"
          :err="formErrors.volume"
        />
        <base-select
            select-label="name"
            name="collection_country"
            v-validate="'required'"
            label="Country of collection"
            v-model="collection_country"
            :options="inputCollectionCountry"
            :searchable="true"
          />
        <base-text
          name="contamination"
          label="Contamination"
          v-model="contamination"
          :units="{units: [getWeightUnit, '%'], source: contaminationUnits}"
          @input-unit="handleOnUnitChange"
          :err="errors.collect('contamination')"
        />
        <base-text
          name="volume_net"
          v-validate="'decimal'"
          :label="`Net volume (${getWeightUnit})`"
          v-model="volumeNet"
          :readonly="true"
          :err="formErrors.volume_net"
        />
        <div class="row mt-4">
        <div class="col-6 text-left">
          <base-button
            v-if="!isLastInputWaste"
            radius="bl"
            component-class="blue"
            @click.native="$router.go(-1)"
          >
            <i class="fas fa-arrow-left mr-3"></i> Previous
          </base-button>
        </div>
        <div class="col-6 text-right">
            <base-button
              radius="br"
              component-class="green filled"
              type="submit"
            >Submit &amp; Go Next <i class="fas fa-arrow-right ml-3"></i>
            </base-button>
        </div>
        </div>
    </form>
  </div>
</template>

<script>
  import * as moment from 'moment';
  import { mapState, mapGetters, mapMutations } from 'vuex';
  import { roundToTwo } from '@/helpers/math';
  import BaseText from '@/components/inputs/text/BaseText';
  import BaseButton from '@/components/inputs/button/BaseButton';
  import BaseSelect from '@/components/inputs/select/BaseSelect';
  import BaseDate from '@/components/inputs/text/BaseDate';
  // import CompositionsService from '@/services/Compositions/CompositionsService';

  import stepValidators from '../StepValidators';

  export default {
    data() {
      return {
        prePostConsumer: 'post-c',
        recycledMaterialsValue: 0,
        volumeGross: null,
        volumeNet: null,
        contamination: 0,
        contaminationUnits: 'kg',
        collection_country: null,
        formErrors: {
          volumeGross: [],
          volume_net: []
        },
        collection_date: '',
        selectedInputWaste: {}
      };
    },

    computed: {
      ...mapState({
        inputSecondData: state => state.submitWaste.inputSecondData,
        inputCompositionWaste: state => state.submitWaste.inputCompositionWaste,
        inputCollectionCountry: state => state.countries.countries,
        lastCompositionInput: state => state.submitWaste.lastCompositionInput,
      }),
      ...mapGetters({
        materials: 'materials/flatMaterials',
      }),
      isLastInputWaste() {
        return this.selectedInputWaste.id !== undefined;
      },
      getWeightUnit() {
        return this.$store.getters['user/getWeightUnit'];
      },
    },

    watch: {
      getWeightUnit(newValue) {
        this.contaminationUnits = newValue;
      },
      volumeGross(newValue) {
        const volumeGrossValue = this.calculateNetVolume(this.contaminationUnits, newValue, this.contamination);
        this.volumeNet = volumeGrossValue;
      },
      contamination(newValue) {
        this.volumeNet = this.calculateNetVolume(this.contaminationUnits, this.volumeGross, newValue);
      },
      selectedInputWaste(newValue) {
        if (newValue && newValue.id) {
          this.$store.commit('submitWaste/setLastCompositionInput', newValue);
        }
      },
      lastCompositionInput: {
        deep: true,
        handler(newValue) {
          this.selectedInputWaste = newValue;
        }
      },

    },

    methods: {
      ...mapMutations({
        resetLastWaste: 'submitWaste/resetLastWaste',
      }),
      resetMaterialWaste() {
        localStorage.removeItem('last_input');
        this.resetLastWaste();
        this.$router.push({ name: 'submit-waste-base' });
      },
      handleOnUnitChange(unit) {
        this.contaminationUnits = unit;
        this.volumeNet = this.calculateNetVolume(this.contaminationUnits, this.volumeGross, this.contamination);
      },
      calculateNetVolume(unit, volumeGross, contamination) {
        let volumeNet = this.volumeGross;
        let contaminationValue = contamination;

        if (typeof contaminationValue === 'string') {
          contaminationValue = contaminationValue.replace(/,/g, '.');
        }
        if (typeof volumeNet === 'string') {
          volumeNet = volumeNet.replace(/,/g, '.');
        }

        if (this.contamination) {
          if (unit === this.getWeightUnit) {
            volumeNet = roundToTwo(volumeNet - contaminationValue);
          } else {
            volumeNet = roundToTwo(volumeNet - this.getValueOfPercent(volumeNet, contaminationValue));
          }
        }

        return volumeNet;
      },
      // TODO do ustawienia w jedny miejscu
      async displayErrors() {
        this.formErrors = {
          volume: [],
          volume_net: [],
        };
        const errors = await this.$validator.errors.items;
        errors.forEach((error) => {
          this.formErrors[error.field] = [error.msg];
        });
      },
      getValueOfPercent(value, percent) {
        return percent / 100 * value;
      },
      async onSubmit () {
        const isFormValid = await this.$validator.validateAll();

        await this.displayErrors();
        if (isFormValid) {
          this.$store.commit('submitWaste/setStepsValidation', {
            stepId: 3,
            isValid: true,
          });

          const { prePostConsumer,
            volumeGross,
            volumeNet,
            contamination,
            collection_date,
          } = this;
          if (this.isLastInputWaste) {
            this.$store.commit('submitWaste/setBaseDataCollectionDate', collection_date);
          }
          this.$store.commit('submitWaste/setInputSecondData', {
            prePostConsumer,
            volumeGross,
            volumeNet,
            contamination,
          });
          this.$router.push({ name: 'submit-waste-input-overview' });
        }
      },
    },

    async mounted () {
      // const { data } = await CompositionsService.getCompositionByType({
      //   company_id: 1,
      //   type: 1,
      // });
      this.selectedInputWaste = this.lastCompositionInput;

      // if (data && data.composition) {
      //   this.compositionInputWaste = data.composition;
      //   const rr = data.composition.find((aa) => {
      //     console.log(aa.name, this.lastCompositionInput);
      //     return aa.name === this.lastCompositionInput.name;
      //   })
      //   rr
      // }

      // this.selectedInputWaste = this.lastCompositionInput;
      this.prePostConsumer = this.inputSecondData.prePostConsumer;
      this.volumeGross = this.inputSecondData.volumeGross;
      this.volumeNet = this.inputSecondData.volumeNet;
      this.contamination = this.inputSecondData.contamination;
      this.collection_date = moment(moment(new Date()), 'YYYY-MM').format('YYYY-MM');
      stepValidators.register(2, async () => {
        const isFormValid = await this.$validator.validateAll();
        return isFormValid;
      });

      stepValidators.register(3, async () => {
        const isFormValid = await this.$validator.validateAll();
        return isFormValid;
      });

    },

    components: {
      'base-text': BaseText,
      'base-button': BaseButton,
      'base-date': BaseDate,
      'base-select': BaseSelect,
    }
  };

</script>

<style lang="scss">
  .btn-custom-sm {
    padding: 5px;
    max-width: 200px;
    margin: auto 0 auto auto;
  }
</style>